/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoucherStatus } from './voucher-status';


export interface VoucherCheckPreviewDTO { 
    codice?: string;
    residuo?: number;
    valore_totale?: number;
    intestatario?: string;
    titolo_bando?: string;
    scadenza?: string;
    stato?: VoucherStatus;
    version?: number;
    codici_fiscali?: Array<string>;
    scaduto?: boolean;
    articoli_mode?: boolean;
}



